import { render } from "./DistributorPaymentHistoryView.vue?vue&type=template&id=f1b6fa3c&scoped=true"
import script from "./DistributorPaymentHistoryView.vue?vue&type=script&lang=js"
export * from "./DistributorPaymentHistoryView.vue?vue&type=script&lang=js"

import "./DistributorPaymentHistoryView.vue?vue&type=style&index=0&id=f1b6fa3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b6fa3c"]])

export default __exports__